import * as React from "react";
import { useDispatch } from "react-redux";
import RouterPage from "./Pages/RouterPage";
import { BookingProvider } from "./context/BookingContext";
import { LanguageProvider } from "./context/LanguageContext";
import { clearTokens } from "./utils/authTokens";
import { clearSession } from "./utils/nightStayAccount";
import { clearUserBookings } from "./store";

const AUTH_EXPIRED_MESSAGE = "Session expired. Kindly login again.";
const AUTH_EXPIRED_EVENT = "portal-auth:expired";
function App({ initialPath }) {
  const dispatch = useDispatch();
  const handledExpiryRef = React.useRef(false);

  const handleSessionExpiry = React.useCallback(() => {
    if (handledExpiryRef.current) return;
    handledExpiryRef.current = true;
    clearSession();
    clearTokens();
    dispatch(clearUserBookings());
    if (typeof window !== "undefined") {
      window.location.assign("/");
    }
  }, [dispatch]);

  React.useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const getMessage = (value) => {
      if (!value) return "";
      if (typeof value === "string") return value;
      if (value instanceof Error) return value.message || "";
      return value?.message || "";
    };

    const handleExpiredEvent = () => handleSessionExpiry();
    const handleUnhandledRejection = (event) => {
      const message = getMessage(event?.reason);
      if (message === AUTH_EXPIRED_MESSAGE) {
        event?.preventDefault?.();
        handleSessionExpiry();
      }
    };
    const handleRuntimeError = (event) => {
      const message = getMessage(event?.error || event?.message);
      if (message === AUTH_EXPIRED_MESSAGE) {
        event?.preventDefault?.();
        handleSessionExpiry();
      }
    };

    window.addEventListener(AUTH_EXPIRED_EVENT, handleExpiredEvent);
    window.addEventListener("unhandledrejection", handleUnhandledRejection);
    window.addEventListener("error", handleRuntimeError);
    return () => {
      window.removeEventListener(AUTH_EXPIRED_EVENT, handleExpiredEvent);
      window.removeEventListener("unhandledrejection", handleUnhandledRejection);
      window.removeEventListener("error", handleRuntimeError);
    };
  }, [handleSessionExpiry]);

  return (
    <LanguageProvider>
      <BookingProvider>
        <div className="App">
          <RouterPage initialPath={initialPath} />
          {/* <LaunchNoticeModal /> */}
          {/* <SupportChatWidget /> */}
        </div>
      </BookingProvider>
    </LanguageProvider>
  );
}

export default App;
